export const Props = () => ({
  //--------------------------------------------------------------------------
  //                        Массив с данными Лидеры роста монет
  //--------------------------------------------------------------------------
  topGainCoins: {
    type: Array,
    default: () => []
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                        Массив с данными Лидеры падения монет
  //--------------------------------------------------------------------------
  topLossCoins: {
    type: Array,
    default: () => []
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  
  //--------------------------------------------------------------------------
  //                        Массив с данными Трендовые коллекции NFT
  //--------------------------------------------------------------------------
  trendingNftCollections: {
    type: Array,
    default: () => []
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                            Идет процесс загрузки данных?
  //----------------------------------------------------------------------------
  isLoading: {
    type: Boolean,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});